import React, { forwardRef } from 'react'

import Toggle from '../Switch'
import styles from './SwitchInput.module.css'

const SwitchInput = forwardRef(({ children, ...rest }, ref) => {
  return (
    <div className={styles.Container}>
      <Toggle {...rest} ref={ref} />
      <span className={styles.Label}>{children}</span>
    </div>
  )
})

export default SwitchInput
